/**
 * 延时队列，该队列存在的意义是发现单纯的用delay setTimeout去延迟，后续执行顺序和延迟顺序会出现不一致，延迟前顺序为1、2、3，延迟后触发顺序为2、3、1或者1、3、2等，暂时无法解释该问题
 */
export class deferQueue {
  constructor() {
    this.queue = [];
    this.running = false;
  }
  _delay(time) {
    return new Promise(resolve => {
      let timeOut = setTimeout(() => {
        clearTimeout(timeOut);
        resolve();
      }, time);
    });
  }
  _push(param) {
    this.queue.push(param);
    this._checkNext();
  }
  _checkNext() {
    if (this.queue.length > 0) {
      if (this.running) return;
      this.running = true;
      this._startExecuteQueue();
    } else {
      this.running = false;
    }
  }
  async _startExecuteQueue() {
    const { executeTime } = this.queue[0];
    if (executeTime <= Date.now()) {
      const { fn, data } = this.queue.shift();
      fn(data);
    } else {
      await this._delay(Math.ceil(Math.abs(executeTime - Date.now())));
    }
    this.running = false;
    this._checkNext();
  }
}
